(() => {
  const STORAGE_KEY = 'lovalo-accessibility-v1';
  const defaults = { font: '100', contrast: false, links: false, readable: false, motion: false };
  const root = document.documentElement;
  const widget = document.querySelector('[data-lovalo-a11y]');
  if (!widget) return;

  const openButton = widget.querySelector('[data-lovalo-a11y-open]');
  const closeButton = widget.querySelector('[data-lovalo-a11y-close]');
  const panel = widget.querySelector('[data-lovalo-a11y-panel]');
  const resetButton = widget.querySelector('[data-lovalo-a11y-reset]');
  const status = widget.querySelector('[data-lovalo-a11y-status]');
  const fontButtons = Array.from(widget.querySelectorAll('[data-lovalo-a11y-font]'));
  const toggleButtons = Array.from(widget.querySelectorAll('[data-lovalo-a11y-toggle]'));
  let state = { ...defaults };

  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (saved && typeof saved === 'object') state = { ...state, ...saved };
  } catch (_error) {
    state = { ...defaults };
  }

  if (!['100', '112', '125'].includes(String(state.font))) state.font = '100';
  ['contrast', 'links', 'readable', 'motion'].forEach((key) => { state[key] = state[key] === true; });

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), details > summary, [tabindex]:not([tabindex="-1"])';
  const getFocusable = () => Array.from(panel.querySelectorAll(focusableSelector)).filter((el) => !el.hidden && el.offsetParent !== null);

  const announce = (message) => {
    status.textContent = '';
    window.setTimeout(() => { status.textContent = message; }, 30);
  };

  const persist = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_error) {}
  };

  const apply = ({ save = true } = {}) => {
    root.dataset.lovaloA11yFont = state.font;
    root.dataset.lovaloA11yContrast = String(state.contrast);
    root.dataset.lovaloA11yLinks = String(state.links);
    root.dataset.lovaloA11yReadable = String(state.readable);
    root.dataset.lovaloA11yMotion = String(state.motion);

    fontButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.lovaloA11yFont === state.font)));
    toggleButtons.forEach((button) => {
      const key = button.dataset.lovaloA11yToggle;
      button.setAttribute('aria-pressed', String(Boolean(state[key])));
    });

    if (state.motion) document.querySelectorAll('video, audio').forEach((media) => media.pause());
    if (save) persist();
  };

  const openPanel = () => {
    panel.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    openButton.setAttribute('aria-label', 'סגירת תפריט נגישות');
    panel.focus();
  };

  const closePanel = ({ restoreFocus = true } = {}) => {
    panel.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    openButton.setAttribute('aria-label', 'פתיחת תפריט נגישות');
    if (restoreFocus) openButton.focus();
  };

  openButton.addEventListener('click', () => panel.hidden ? openPanel() : closePanel());
  closeButton.addEventListener('click', () => closePanel());

  fontButtons.forEach((button) => {
    button.addEventListener('click', () => {
      state.font = button.dataset.lovaloA11yFont;
      apply();
      announce(`גודל הטקסט שונה ל-${button.textContent.trim()}`);
    });
  });

  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const key = button.dataset.lovaloA11yToggle;
      state[key] = !state[key];
      apply();
      const label = button.textContent.trim().replace(/\s+/g, ' ');
      announce(`${label} ${state[key] ? 'הופעל' : 'כובה'}`);
    });
  });

  resetButton.addEventListener('click', () => {
    state = { ...defaults };
    apply();
    announce('כל התאמות הנגישות אופסו');
  });

  document.addEventListener('keydown', (event) => {
    if (panel.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closePanel();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!panel.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (!panel.hidden && !widget.contains(event.target)) closePanel({ restoreFocus: false });
  });

  apply({ save: false });
})();
